<template>
  <div v-if="visible">
    <v-menu
      top
      close-delay="1"
      content-class="elevation-11 opacity-none main-note-content border-radius-4"
      allow-overflow
      color="#e4f3f7"
      transition="slide-y-transition"
      :open-on-hover="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            data-cy="notePill-items"
          class="position-absolute rounded-circle pa-0 opacity-5"
          fab
          small
          color="secondary"
          v-bind="attrs"
          v-on="on"
          :loading="btnLoaded"
        >
          <v-icon>mdi-file</v-icon>
        </v-btn
        >
      </template>
      <v-row class="note-info position-relative d-flex justify-start align-start flex-column px-4 py-3 opacity-none">
        <v-col class="d-flex flex-column justify-start align-start mx-3 w-100">
          <div class="d-flex flex-row justify-start align-start mx-3 mb-4">
            <img :src="indexImg" class="img-index mr-2" alt=""/><span
            class="text-h5 ma-0 primary--text"
          >{{ $t('bookReading.my_notes') }}</span
          >
          </div>
          <span class="primary--text text-subtitle-1 w-100">{{ noteText }} </span>
        </v-col>
        <v-col class="d-flex justify-center flex-column align-center ">
          <span class="text--primary text-body-1 w-80 py-3 note-content border-radius-2 ">{{ data.content }} </span>
          <v-btn data-cy="notePill-delete-button"
          color="secondary" rounded class="py-4 w-50 ma-5 cursor-pointer" @mouseup.prevent="noteAction"> Eliminar Nota</v-btn>
        </v-col>
      </v-row>
    </v-menu>
  </div>
</template>
<script>
  import { mapActions } from 'vuex'
  import bookUserNotesService from '@/services/bookUserNotes'

  const indexImg = require('@/assets/img/icons/reading/icon-notes-2.svg')

  export default {
      props: {
          data: { type: Object, default: null },
          note_number: { type: Number, default: null },
          visible: { type: Boolean, default: false },
      },
      computed: {
          noteText(){
              return `${this.$t('bookReading.note_pill_msg')} ${this.$moment(this.data.createdDate).fromNow()}`;
          }
      },
      data() {
          return {
              indexImg,
              btnLoaded: false,
          }
      },
      methods: {
          ...mapActions('bookReading', [
              'setBookUserNotes',
          ]),
          async noteAction(){
              await bookUserNotesService
                  .deleteNote(this.data.id)
                  .then((response) => {
                      this.setBookUserNotes(response.content)
                  })
                  .catch((error) => console.error(error))
              this.btnLoaded = !this.btnLoaded
          }
      }
  }
</script>
<style>
.note-info {
  width: 80vh;
}
.main-note-content {
  border: 2px solid #4BADA1;
  background: radial-gradient(circle, #F4F9F9 0%, #CEECEA 100%)
}
.note-content {
  background: #CAE4E3;
}
</style>
